import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { Box, Typography, TextField } from '@material-ui/core'
import { AppButton, DisplayMessage, Loader } from '../../Components'
import { TableOutline, Cards, OutlinedButton } from '../../elements'
import {
  tableHeadings,
} from './constant'
import { useStyles } from './style'
import Breadcrumb from '../../Components/Breadcrumbs'
import { tagsService } from '../../Services/TagsService/TagsService'
import StatusButton from '../../Components/StatusButton'
import * as messageTypes from '../../utils/messageTypes'
import { COMMON } from '../../utils/constants'
import EditIcon from '@material-ui/icons/Edit'
import CustomDialog from '../../Components/CustomDialog'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { programService } from '../../Services'
import Icon from '../../utils/icons'
import { pushToDataLayer, USERBEHAVIOURTRACKING } from '../../utils/gaEnvironment'

const validationSchema = yup.object({
  name: yup.string('Enter tag name')
    .max(15, 'Tag name should be of maximum 15 characters')
    .matches(/^(^[A-Za-z0-9][A-Za-z0-9_.()\s]+)$/, 'Tag name not valid. Only letters, numbers and _,.,(,) allowed')
    .required('Tag name is required'),
})

function TagsManager(props) {
  const classes = useStyles()
  const [allTags, setAllTags] = useState([])
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(true)
  const [tableLoading, setTableLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [totalCount, setTotalCount] = useState()
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState()
  const [openEditModal, setOpenEditModal] = useState(false)
  const [editData, setEditData] = useState('')
  const [program, setProgram] = useState({})

  const programId = props?.match?.params?.programId
  const formik = useFormik({
    initialValues: {
      name: editData.name,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      pushToDataLayer({ event: USERBEHAVIOURTRACKING, accountID: props.accountId, programID: props.programId })
      submitEditForm(values)
    },
  })

  const handlePageChange = (newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (value) => {
    setRowsPerPage(value)
    setPage(1)
  }

  const getProgram = () => {
    const { currentUser } = props
    programService.getProgramsById(currentUser.account_id, programId)
      .then(programData => {
        setProgram(programData)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const getAllTags = () => {
    const { currentUser } = props
    setLoading(true)
    setTableLoading(true)
    tagsService.getAllTags(programId, currentUser.account_id, page, rowsPerPage)
      .then(tagsData => {
        setAllTags(tagsData.tags)
        setTagsTable(tagsData.tags)
        setTotalCount(tagsData.total_count)
        setLoading(false)
        setTableLoading(false)
      })
      .catch(error => {
        setLoading(false)
        setTableLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const setTagsTable = (tagsData) => {
    let tagsTable = []
    tagsData.map(obj => {
      let tableObj = [
        {
          id: 'name',
          tag: obj,
          value: props.isAdmin ? <Link className={classes.linkStyle} onClick={() => { setEditData(obj); setOpenEditModal(true) }}>{_.get(obj, 'name', '')}</Link> : <span>{_.get(obj, 'name', '')}</span>,
        },
        {
          id: 'action',
          value: <EditIcon className={`${classes.editIcon} ${props.isViewOnly && classes.disabledIcon}`} onClick={() => { !props.isViewOnly && props.history.push({ pathname: `${props.location.pathname}/edit-tag`, state: { tag: obj, programId: programId } }) }} />
        },
        {
          id: 'totalSystems',
          value: _.get(obj, 'total_systems', '-'),
        },
        {
          id: 'status',
          value: <StatusButton
            text={`${obj.missing_values == 0 ? 'Updated' : (obj.missing_values < obj.total_systems) ? `Missing values for ${obj.missing_values} system(s)` : 'Missing values for all systems'}`}
            color={`${obj.missing_values == 0 ? '#7ACF38' : (obj.missing_values < obj.total_systems) ? '#FFD800' : '#FF6565'}`}
          />
        }
      ]
      tagsTable.push(tableObj)
    })
    setTableData(tagsTable)
  }

  const handleMessageClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
  }

  const renderIcon = (errors, touched) => {
    return touched ? _.isUndefined(errors) ? <Icon src="circleTick" /> : <Icon src="circleCross" /> : <></>
  }

  const getEditmodalContent = () => (
    <form onSubmit={formik.handleSubmit}>
      <TextField
        autoFocus
        id="name"
        name="name"
        label="Tag name"
        disabled={props.isViewOnly}
        value={formik.values.name}
        onChange={formik.handleChange}
        onBlur={(e) => formik.setFieldValue('name', e.target.value.trim())}
        fullWidth
        InputProps={{
          endAdornment: renderIcon(formik.errors.name, formik.touched.name),
        }}
        error={formik.touched.name && Boolean(formik.errors.name)}
        helperText={formik.touched.name && formik.errors.name}
      />
      <Box pt={1}>
        <AppButton disabled={props.isViewOnly} type="submit" text="Submit" />
      </Box>
    </form>
  )

  const submitEditForm = (values) => {
    const { currentUser } = props
    const method = 'put'
    tagsService.submitTag(currentUser.account_id, programId, values, method, editData)
      .then(tagsData => {
        setOpenEditModal(false)
        setOpen(true)
        setMessage('Tag updated successfully')
        setMessageType(messageTypes.SUCCESS)
        getAllTags()
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })

  }

  useEffect(() => {
    if (Object.keys(program).length <= 0) {
      getProgram()
    }
  }, [programId])

  useEffect(() => {
    getAllTags()
  }, [page, rowsPerPage])

  const renderTagsContent = () => {
    return (
      <Box>
        <TableOutline
          tableHeadings={tableHeadings}
          tableData={tableData}
          totalElement={totalCount}
          loading={tableLoading}
          pagination={tableData.length > 0}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handlePageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Box>
    )
  }

  const getBreadcrumbs = () => {
    let value = [{ 'Home': '/' }, { 'Programs': '/programs' }]
    if (program) {
      value.push({ [program?.program_name_admin_ui]: `/programs/${program.id}` })
      value.push({ 'Tags Manager': `/programs/${program.id}/tags-manager` })
    } else {
      value.push({ 'Tags Manager': '' })
    }
    return value
  }

  return (
    <Box>
      <Loader loading={loading} />
      <Breadcrumb value={getBreadcrumbs()} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={handleMessageClose} />
      <CustomDialog open={openEditModal} handleClose={() => setOpenEditModal(false)} title="Rename Tag" content={getEditmodalContent()} maxWidth="xs" fullWidth />
      <Box className={classes.headerWrapper}>
        <Typography className={classes.title}>Tags Manager</Typography>
        {!props.isViewOnly && (props.isSuperAdmin || props.isAdmin) ?
          <OutlinedButton label='create new tag' onClick={() => { props.history.push({ pathname: `${props.location.pathname}/create-tags`, state: { programId: programId } }) }} /> : ''
        }
      </Box>
      <Cards className={classes.cardWrapper} children={renderTagsContent()} />
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser, isSuperAdmin, isAdmin, isViewOnly } = auth
  return { authUser, currentUser, isSuperAdmin, isAdmin, isViewOnly }
}

export default connect(mapStateToProps, {})(TagsManager)